import React from "react";
import { SignIn } from "@clerk/clerk-react";

const LoginPage = () => {
  return (
    <div style={{
      width: "100%",
      height: "100vh",
      background: "#f1debd",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "24px",
    }}>
      <img
        src="/photos/logo blanc.png"
        alt="logo"
        style={{
          height: "80px",
          background: "#547d9d",
          padding: "10px 16px",
          borderRadius: "12px",
        }}
      />
      <SignIn afterSignInUrl="/" routing="hash" />
    </div>
  );
};

export default LoginPage;
